// /* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { useContext } from "react";
import { IntlShape, WrappedComponentProps, injectIntl } from "react-intl";
import { UseTranslateType, Window } from "../@types";
import EnglishTranslations from "../translations/en-US.json";
declare let window: Window;

export const IntlContext = React.createContext<IntlShape>({} as IntlShape);

const IntlProvider: React.FunctionComponent<WrappedComponentProps> = ({
  children,
  intl,
}) => {
  return <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>;
};

// turn the old context into the new context
export const InjectIntlContext = injectIntl(IntlProvider);

// Allows for intellisense autocomplete of PA key names
export type TranslationKey = keyof typeof EnglishTranslations;

// Makes PhraseApp compatible ID strings, for use with the in context editor
const phraseappEscapeId = (id: string): string => `{{__phrase_${id}__}}`;

// the format message hook
// eslint-disable-next-line @typescript-eslint/ban-types
export const useFormatMessage = (): Function => {
  const intl = useContext(IntlContext);

  if ((window as Window).PHRASEAPP_ENABLED) {
    return ({ id }: { id: string }): string => phraseappEscapeId(id);
  } else {
    return intl.formatMessage;
  }
};

export const useIntl = (): IntlShape => {
  return useContext(IntlContext);
};

export const useTranslate = (): UseTranslateType => {
  const fm = useFormatMessage();
  return (id: TranslationKey | string): string => {
    if (!EnglishTranslations[id]) {
      return id;
    }

    if ((window as Window).PHRASEAPP_ENABLED) {
      return phraseappEscapeId(id);
    } else {
      return fm({ id });
    }
  };
};
